<template>
	<div class="container-fluid">
		<div class="row" style="padding-top: 5%;">
			<div class="md-layout-item md-size-80 offset-1">
				<md-card>
					<md-card-header class="md-card-header-icon md-card-header-primary">
						<div class="card-icon">
						    <md-icon>lock_open</md-icon>
						</div>						
						<h4 class="title">{{ trans('common.password_reset') }}</h4>
					</md-card-header>

					<md-card-content>
						<div class="md-layout">
							<remember-form @rememberSuccess="rememberSuccess"></remember-form>
						</div>
					</md-card-content>
				</md-card>				
			</div>
		</div>
	</div>
</template>

<script>
	import RememberForm from './RememberForm.vue'

	export default {
		components: {
			'remember-form': RememberForm
		},
		methods: {
			rememberSuccess(data) {
				this.$router.push({name: 'login'});
			}
		}
	}
</script>
